import { Alert } from 'antd';
import React from 'react';

import type { TechStackItem } from '@/api/project-details/mocks/projectHome.types';
import { TechStackSelector } from '@/components/project_details_components/TechStackSelector';

export interface TechStackCardProps {
  items: TechStackItem[];

  onItemAdd?: (item: { name: string; category: string }) => Promise<void>;

  onItemDelete?: (itemId: string) => Promise<void>;

  isLoading?: boolean;

  isDeletingId?: string | null;

  canManageTechStack?: boolean;

  error?: string | null;

  onErrorDismiss?: () => void;
}

export function TechStackCard({
  items,
  onItemAdd,
  onItemDelete,
  isLoading = false,
  isDeletingId = null,
  canManageTechStack = false,
  error = null,
  onErrorDismiss,
}: Readonly<TechStackCardProps>): React.ReactElement {
  return (
    <>
      {error && (
        <Alert
          message="Permission Denied"
          description={error}
          type="error"
          showIcon
          closable
          onClose={onErrorDismiss}
          style={{ marginBottom: '16px' }}
        />
      )}
      <TechStackSelector
        items={items}
        onItemAdd={onItemAdd}
        onItemDelete={onItemDelete}
        isLoading={isLoading}
        isDeletingId={isDeletingId}
        canManageTechStack={canManageTechStack}
      />
    </>
  );
}
